import React from 'react';
import cn from 'clsx';
import PropTypes from 'prop-types';

import BarRating from '../../library/bar-rating/bar-rating';
import DTGauge from '../../library/gauge/gauge';
import StarBarRating from '../../library/star-bar-rating/star-bar-rating';
import StarRating from '../../library/star-rating/star-rating';

import styles from './review-overview.scss';

function ReviewOverview(props) {
  const {
    averageAnswerRatings,
    className = '',
    numberOfReviews = 0,
    ratingCounts,
    recommendedCount = 0,
    recommendedMessage,
    totalRating
  } = props;

  return (
    <div className={cn(styles['container'], `${className} review-overview`)}>
      <div
        className={cn(
          styles['overall'],
          className ? `${className}__overall` : null
        )}
      >
        <div className={styles['overall-rating']}>
          {totalRating && (
            <DTGauge
              draw
              fillPerc={totalRating / 5}
              gaugeHeight={87}
              label="Out Of 5"
              labelPos={{ y: 172 }}
              showBezel={false}
              showTrack
              value={Number(totalRating || 0).toFixed(1)}
              valuePos={{ y: 136 }}
            />
          )}
        </div>
        <div className="recommended">
          {!isNaN(recommendedCount) && numberOfReviews && (
            <>
              <div className={styles['recommended-perc']}>
                <span className={styles['recommended-perc-value']}>
                  {`${Math.round((recommendedCount / numberOfReviews) * 100)}%`}
                </span>
                Recommended
              </div>

              {recommendedMessage && (
                <span className={styles['recommended-count']}>
                  {recommendedCount} of {numberOfReviews} {recommendedMessage}
                </span>
              )}
            </>
          )}

          {totalRating && (
            <div className={styles['star-rating']}>
              <StarRating rating={totalRating} showRating={false} />
              <span className={styles['total-review-count']}>
                {numberOfReviews} Reviews
              </span>
            </div>
          )}
        </div>
      </div>

      <div
        className={cn(
          styles['ratings'],
          className ? `${className}__ratings` : null
        )}
      >
        {ratingCounts && numberOfReviews && (
          <div className={styles['by-review']}>
            <StarBarRating
              className={styles['star-bar-rating-by-review']}
              heading="Ratings By Review"
              ratingSummaries={ratingCounts}
              totalCount={numberOfReviews}
            />
          </div>
        )}

        {averageAnswerRatings && (
          <div
            className={cn(
              styles['average-ratings'],
              className ? `${className}__ratings-average-ratings` : null
            )}
          >
            <BarRating
              averageRatings={averageAnswerRatings}
              heading="Average Customer Ratings"
            />
          </div>
        )}
      </div>
    </div>
  );
}

ReviewOverview.propTypes = {
  averageAnswerRatings: PropTypes.array,
  className: PropTypes.string,
  numberOfReviews: PropTypes.number,
  ratingCounts: PropTypes.array,
  recommendedCount: PropTypes.number,
  recommendedMessage: PropTypes.string,
  totalRating: PropTypes.number
};

export default ReviewOverview;
